import { createContext, useContext } from "react"

import type { FilterFieldType } from "~/utils/filter"

export type FilterFieldsOverride = {
  fields: FilterFieldType[]
  optionsByField?: Record<string, string[]>
}

export const FilterFieldsOverrideContext = createContext<FilterFieldsOverride | null>(null)

export function useFilterFieldsOverride() {
  return useContext(FilterFieldsOverrideContext)
}
